import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../material.module";
import { SidebarComponent } from "./sidebar.component";
import { HttpClientModule } from "@angular/common/http";

@NgModule({
  imports: [RouterModule, CommonModule, HttpClientModule, MaterialModule],
  declarations: [SidebarComponent],
  exports: [SidebarComponent]
})
export class SidebarModule { }
